import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatNativeDateModule} from '@angular/material/core';
import {BrowserModule} from '@angular/platform-browser';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatTabsModule} from '@angular/material/tabs';


import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { FuseSharedModule } from '@fuse/shared.module';
import { FuseConfirmDialogModule, FuseSidebarModule,FuseWidgetModule } from '@fuse/components';


import { DispatchComponent } from 'app/main/pagina/certificar/dispatch/dispatch.component';

//import { FormDialogComponent } from 'app/main/pagina/certificar/dispatch/formdialog/form.component';

import { AlertDialogComponent } from 'app/main/pagina/certificar/alertdialog/alertdialog.component';


const routes = [
    {
        path     : 'dispatch',
        component: DispatchComponent
    }
];

@NgModule({
    declarations: [
        //DispatchComponent,
        //AlertDialogComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatRippleModule,
        MatTableModule,
        MatToolbarModule,
        MatButtonToggleModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        MatTabsModule,

        MatNativeDateModule,
        ReactiveFormsModule,

        FuseSharedModule,
        FuseConfirmDialogModule,
        FuseSidebarModule,
        FuseWidgetModule,
        BrowserModule,
         FormsModule

    ],
    entryComponents: [ AlertDialogComponent ]
})
export class DispatchModule
{
}
